<div class="flex flex-col max-w-240 md:min-w-200 max-h-screen -m-6">

    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{dialogTitle}}</div>
        <button mat-icon-button (click)="onClose()" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>

    <div class="flex flex-auto overflow-hidden">
        <div class="flex flex-col flex-auto sm:mb-18 overflow-hidden sm:overflow-y-auto">
            <ng-container *ngIf="payments$ | async as payments">
                 <ng-container *ngIf="payments.length; else noPayments"> 
                    <div class="grid">
                        <!-- Header -->
                        <div class="invoicepaymentlist-grid z-6 sticky top-0 grid gap-4 py-4 px-6 md:px-8 shadow text-md font-semibold text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5"
                            matSort matSortDisableClear>
                            <div class=" sm:block" [mat-sort-header]="'id'">
                                Payment Id
                            </div>
                            <div class="lg:block" [mat-sort-header]="'date'">
                                Date
                            </div>
                            <div class="lg:block" [mat-sort-header]="'bankName'">
                                Bank Name
                            </div>
                            <div class="lg:block" [mat-sort-header]="'bankBranchName'">
                                Bank Branch Name
                            </div>
                            
                            <div class="lg:block" [mat-sort-header]="'amount'">
                                Amount
                            </div>
                            <div class="lg:block" [mat-sort-header]="'tdsAmount'">
                                TDS Amount
                            </div>
                           
                        </div>
                        <!-- Rows -->
                        <ng-container *ngIf="(payments$ | async) as payments">
                            <ng-container *ngFor="let payment of payments; trackBy: trackByFn">
                              
                                <div class="invoicepaymentlist-grid grid items-center gap-4 py-4 px-6 md:px-8 border-b text-sm">

                                    <div class="md:block">
                                        {{payment.paymentId}}
                                    </div>

                                    <div class="md:block">
                                        {{payment.date | date:'dd-MM-yyyy'}}
                                    </div>

                                    <div class="md:block">
                                        {{payment.bankName}}
                                    </div>
                                    <div class="md:block">
                                        {{payment.bankBranchName}}
                                    </div>
                                   
                                    <div class="md:block">
                                        {{payment.amount}}
                                    </div>
                                    <div class="md:block">
                                        {{payment.kasarAmount}}
                                    </div>
                                </div>
                                <div class="grid">
                                    <ng-container *ngIf="selectedPayment?.id === payment.id">
                                        <ng-container
                                            *ngTemplateOutlet="rowDetailsTemplate; context: {$implicit: payment}"></ng-container>
                                    </ng-container>
                                
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
            </ng-container>
            </ng-container>
            </div>
            </div>
            </div>
            

        
